import * as React from "react";
import { useState } from "react";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { getQueryParameters } from "../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Literature } from "./Components/Literature";
import { Tool } from "./Components/Tool";
import { ToolAndLiteratureTab } from "./Resource/Content";

export const ToolsAndLiterature = () => {
    const [tabKey, setKey] = useState(
        CommonHelper.isNullOrEmpty(getQueryParameters()["tab"])
            ? ToolAndLiteratureTab.Tool
            : getQueryParameters()["tab"]
    );

    const getContent = (key: ToolAndLiteratureTab) => {
        let _content = null;

        switch (key) {
            case ToolAndLiteratureTab.Tool:
                _content = <Tool />;
                break;
            case ToolAndLiteratureTab.Literature:
                _content = <Literature />;
                break;
        }
        return _content;
    };

    const tabs = [];
    for (const key in ToolAndLiteratureTab) {
        tabs.push(
            <button
                role="tab"
                key={`tab-${key}`}
                className="item"
                aria-selected={tabKey === ToolAndLiteratureTab[key]}
                onClick={() => setKey(ToolAndLiteratureTab[key])}
            >
                {ToolAndLiteratureTab[key]}
            </button>
        );
    }
    return (
        <div role="main" id="main">
            <h1>Tools and literature</h1>

            <nav className="tabs mb-20 ad d1">
                <div role="tablist">{tabs}</div>  
            </nav>
            {getContent(tabKey)}
        </div>
    );
};
